import { render, staticRenderFns } from "./college.vue?vue&type=template&id=1276ad13&scoped=true&"
import script from "./college.vue?vue&type=script&lang=js&"
export * from "./college.vue?vue&type=script&lang=js&"
import style0 from "./college.vue?vue&type=style&index=0&id=1276ad13&lang=less&scoped=true&"
import style1 from "./college.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1276ad13",
  null
  
)

export default component.exports